var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{staticClass:"wrap",attrs:{"xs11":!_vm.full}},[_c('div',{staticClass:"date-range-area",style:('left:' + _vm.paddingLeftPercent + ';width:' + _vm.dateRangeWidthPercent)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }